/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ColorRing } from "react-loader-spinner";
import { useMutation } from "@apollo/client";
import { RESET_PASSWORD } from "../../Graphql/Mutation/Auth/AuthMutation";
import { initialValuesReset, resetSchema } from "./schema";
import { useFormik } from "formik";
import toast from "react-hot-toast";

const ResetSection = () => {

  const navigate = useNavigate();
  const [UserReset, { loading: loginLoading }] =
    useMutation(RESET_PASSWORD);


  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialValuesReset,
      validationSchema: resetSchema,
      onSubmit: async(values) => {
        console.log(values);
        const {
          email,
          password,
          token
        } = values;
  
        try {
          const loginResponse = await UserReset({
            variables: {
              email,
              newPassword:password,
              resetToken:token
            },
          });
  
          console.log(loginResponse, "loginResponse");
          if (loginResponse && loginResponse.data) {
            if(loginResponse?.data?.userReset){
              toast.success('Reset Password Successfully')
            navigate("/login");
          }
        }
    } catch (error) {
          console.log(error, "error");
        }
      },
    });
    

  return (
    <>
      <div className="body_content mt40" style={{ background: "#FFEDE8" }}>
        <section className="our-login">
          <div className="container">
            <div className="row">
              <div
                className="col-lg-6 m-auto wow fadeInUp"
                data-wow-delay="300ms"
              >
                <div className="main-title text-center">
                  <h2 className="title">Reset Password</h2>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="row wow fadeInRight" data-wow-delay="300ms">
                <div className="col-xl-6 mx-auto">
                  <div className="log-reg-form search-modal form-style1 bgc-white p40 p30-sm default-box-shadow1 bdrs12">
                   
                    <div className="mb10">
                      <label className="form-label fw500 dark-color">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="enter your email"
                        onChange={handleChange}
                        value={values.email}
                        onBlur={handleBlur}
                      />
                      <span className="error">
                        {touched.email && errors.email}
                      </span>
                    </div>
                    <div className="mb10">
                      <label className="form-label fw500 dark-color">
                      Reset Token
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="token"
                        placeholder="enter your reset token"
                        onChange={handleChange}
                        value={values.token}
                        onBlur={handleBlur}
                      />
                      <span className="error">
                        {touched.token && errors.token}
                      </span>
                    </div>
                    <div className="mb10">
                      <label className="form-label fw500 dark-color">
                        Password
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        placeholder="*******"
                        onChange={handleChange}
                        value={values.password}
                        onBlur={handleBlur}
                      />
                      <span className="error">
                        {touched.password && errors.password}
                      </span>
                    </div>

                    <div className="checkbox-style1 d-block d-sm-flex align-items-center justify-content-end mb20">
                      
                      <Link className="fz14 ff-heading" to='/forgot'>Forgot password?</Link>
                    </div>
                  
                    <div className="d-grid mb10">
                      <button className="ud-btn btn-thm" type="submit">
                      {loginLoading ? (
                          <ColorRing
                            visible={true}
                            height="30"
                            width="30"
                            ariaLabel="color-ring-loading"
                            wrapperStyle={{}}
                            wrapperClass="color-ring-wrapper"
                            colors={["#fff", "#fff", "#fff", "#fff", "#fff"]}
                          />
                        ) : (
                          "Reset Password"
                        )}
                      </button>
                    </div>
                   
                  </div>
                </div>
              </div>
            </form>
          </div>    
        </section>
        <a className="scrollToHome">
          <i className="fas fa-angle-up" />
        </a>
      </div>
    </>
  );
};

export default ResetSection;
